import * as React from "react";
import {
  TextField,
  Button,
  Stack,
  InputAdornment,
  InputLabel,
  Select,
} from "@mui/material";
import { Check, Save } from "@mui/icons-material";
import ModalUI from "../UI/ModalUI";
import { useDispatch, useSelector } from "react-redux";
import { submitInputeLines } from "../../store/formInputesSubmission";
import InputSelect from "../UI/FormGridInputetComponents/InputSelect";
import InputDate from "../UI/FormGridInputetComponents/InputDate";
import { convertInputValueForInsert } from "./InputetTableImportExcel";

const EditorInputs = (props) => {
  const {
    isstatusnew,
    open,
    formId,
    formData,
    inputsEdit,
    onClose,
    onSubmitData,
    name,
    editAccess = true,
    order,
  } = props;

  const tempState = Object.fromEntries(formData.map((item) => [item.id, ""]));

  const [state, setState] = React.useState(null);
  const [formDataSate, setFormDataSate] = React.useState(null);
  const [errorValues, setErrorValues] = React.useState([]);

  React.useEffect(() => {
    setErrorValues([]);
    if (isstatusnew) {
      setState(tempState);
      setFormDataSate(formData);
    } else {
      setState(inputsEdit);
      setFormDataSate(formData);
    }
  }, [formData, open, inputsEdit]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setState({ ...state, [name]: value ? value : "" });
  };

  const checkError = (item) => {
    if (errorValues.find((element) => element === item)) {
      return true;
    } else {
      return false;
    }
  };

  const transformObjectToArray = (data) => {
    return [
      {
        answers: Object.entries(data).map(([formInputId, answer]) => ({
          formInputId,
          answer: convertInputValueForInsert(answer), // Konverton në numër nëse është numerik
        })),
        order: order ? order : null,
      },
    ];
  };

  const saveData = () => {
    var initialError = [];
    Object.keys(state).map(function (key, index) {
      if (state[key] !== "" || Object.keys(state[key]).length !== 0) {
      } else {
        initialError.push(key);
      }
    });

    // setErrorValues(initialError);

    var initialErrorTemp = [];
    initialErrorTemp = initialError.filter((item) => item !== "id"); // remove id item

    // if (initialErrorTemp.length === 0) {
    if (initialErrorTemp) {
      const { id, ...tempStateData } = state;

      const dataValid = {
        id: formId,
        lines: transformObjectToArray(tempStateData),
      };

      onSubmitData(dataValid);
    }
    // dispatch(submitInputeLines({ item: dataValid }));
    // onClose();
  };

  if (state === null) return <p>Loading...</p>;

  return (
    <ModalUI {...props} width="980px" formname={name} onClose={onClose}>
      {formData?.map((item) => {
        return item?.type === "SELECT" ? (
          <Stack spacing={2}>
            <InputSelect
              id={item?.id}
              name={item?.id}
              label={item.label}
              options={item?.properties?.options}
              value={state[item?.id]}
              withLabel
              error={checkError(item.id)}
              helperText={
                checkError(item.id) ? item.label + " është i detyruar" : null
              }
              disabled={!editAccess}
              // disabled={
              //   (stateForm === "old" && !isGlobalEditor) ||
              //   user?.role === "ROLE_EDITOR"
              // }
              onChange={(e) => {
                setState({
                  ...state,
                  [item?.id]: e.target.value ? e.target.value : "",
                });
              }}
            />
          </Stack>
        ) : item?.type === "DATE" ? (
          <Stack spacing={2}>
            <InputDate
              id={item?.id}
              // error={checkError(item.id)}
              helperText={
                checkError(item.id) ? item.label + " është i detyruar" : null
              }
              disabled={!editAccess}
              name={item?.id}
              label={item.label}
              value={state[item?.id]}
              onChange={(e) => {
                setState({
                  ...state,
                  [item?.id]: e ? e : "",
                });
              }}
            />
          </Stack>
        ) : (
          <Stack spacing={2}>
            <TextField
              name={item.id}
              disabled={!editAccess}
              autoComplete="off"
              id={item.id}
              type={item?.type}
              variant="outlined"
              error={checkError(item.id)}
              helperText={
                checkError(item.id) ? item.label + " është i detyruar" : null
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    sx={{
                      "&.MuiInputAdornment-root": {
                        minWidth: "210px",
                      },
                    }}
                    position="start"
                  >
                    {item.label}
                  </InputAdornment>
                ),
              }}
              value={state[item.id]}
              onChange={handleInputChange}
            />
          </Stack>
        );
      })}
      {editAccess && (
        <Stack sx={{ display: "flex", width: "100%" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "primary.dark",
              display: "flex",
              marginTop: "40px",
            }}
            startIcon={<Save />}
            onClick={saveData}
          >
            {isstatusnew ? "Shto" : "Ndrysho"}
          </Button>
        </Stack>
      )}
    </ModalUI>
  );
};
export default EditorInputs;
